<nb-layout center>
	<nb-layout-column>
		<nb-card>
			<nb-card-header>
				<nav class="navigation">
					<a aria-label="Back" class="link" routerLink="/pages">
						<nb-icon icon="arrow-ios-back-outline"></nb-icon>
					</a>
				</nav>
			</nb-card-header>
			<ng-container *ngIf="codecontainer==true">
				<nb-card-body>
					<div class="login-container">
						<h1 id="title" class="title">Forgot Password</h1>
						<p class="sub-title">Enter security code that has been sent your email address</p>

						<!-- <nb-alert *ngIf="!!errorMessage" outline="danger" role="alert">
							<p class="alert-title"><b>{{ 'Errors.VerifycodeErrorMessage' | translation }}</b></p>
							<p>
								{{errorMessage}}
							</p>
						</nb-alert> -->

						<form [formGroup]="form" aria-labelledby="title">

							<div class="form-control-group">
								<label class="label" for="input-email">Enter security code:</label>
								<input nbInput
										fullWidth
										formControlName="code"
										name="code"
										id="input-code"
										placeholder="Security Code"
										autofocus
										[status]="form.controls['code'].dirty ? (form.controls['code'].invalid  ? 'danger' : 'success') : ''"
										[required]="true"
										[attr.aria-invalid]="form.controls['code'].invalid && form.controls['code'].touched ? true : null">
								<ng-container *ngIf="form.controls['code'].invalid && form.controls['code'].touched">
									<p class="error-message" *ngIf="form.controls['code'].errors?.required">
										Security code is required!
									</p>

								</ng-container>
							</div>

							<button nbButton
									fullWidth
									status="success"
									[disabled]="form.invalid"
									[nbSpinner]="loading" nbSpinnerStatus="disabled"
									(click)="onVerify()">
								Verify Code
							</button>
						</form>

						<section class="sign-in-or-up" aria-label="Sign in or sign up">
							<p><a class="text-link" routerLink="/login">Back to Log In</a></p>
						</section>

					</div>
				</nb-card-body>
			</ng-container>
			<ng-container *ngIf="passwordcontainer==true">
				<nb-card-body>
					<div class="login-container">
						<h1 id="title" class="title">Forgot Password</h1>
						<p class="sub-title">Enter New Password for login</p>

						<!-- <nb-alert *ngIf="!!errorMessage" outline="danger" role="alert">
							<p class="alert-title"><b>{{ 'Errors.VerifycodeErrorMessage' | translation }}</b></p>
							<p>
								{{errorMessage}}
							</p>
						</nb-alert> -->

						<form [formGroup]="newform" aria-labelledby="title">

							<div class="form-control-group">
								<label class="label">Password: <span
									style="color: red;">*</span></label>
								<input nbInput
									   type="password"
									   name="password"
									   placeholder="Password"
									   fullWidth
									   formControlName="password"
									   [status]="newform.controls['password'].dirty ? (newform.controls['password'].invalid  ? 'danger' : 'success') : ''"
									   [required]="true"
									   [minlength]="6"
									   [maxlength]="255"
									   [attr.aria-invalid]="newform.controls['password'].invalid && newform.controls['password'].touched ? true : null">
								<ng-container
									*ngIf="newform.controls['password'].invalid && newform.controls['password'].touched">
									<p class="error-message" *ngIf="newform.controls['password'].errors?.required">
										Password is required!
									</p>
									<p class="error-message"
									   *ngIf="newform.controls['password'].errors?.minlength || newform.controls['password'].errors?.maxlength">
										Password should contains
										from 6
										to 255
										characters
									</p>
								</ng-container>
							</div>

							<button nbButton
									fullWidth
									status="success"
									[disabled]="newform.invalid"
									[nbSpinner]="loading" nbSpinnerStatus="disabled"
									(click)="onresetpassword()">
								Submit
							</button>
						</form>

						<section class="sign-in-or-up" aria-label="Sign in or sign up">
							<p><a class="text-link" routerLink="/login">Back to Log In</a></p>
						</section>

					</div>
				</nb-card-body>
			</ng-container>


		</nb-card>
	</nb-layout-column>
</nb-layout>
